var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsInactiveNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1732_1874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.667 5.83333C11.667 5.21449 11.9128 4.621 12.3504 4.18342C12.788 3.74583 13.3815 3.5 14.0003 3.5C14.6192 3.5 15.2127 3.74583 15.6502 4.18342C16.0878 4.621 16.3337 5.21449 16.3337 5.83333C17.6735 6.46687 18.8156 7.45305 19.6377 8.68618C20.4598 9.91932 20.9308 11.3529 21.0003 12.8333V16.3333C21.0881 17.0587 21.345 17.7532 21.7503 18.3611C22.1555 18.9691 22.6979 19.4733 23.3337 19.8333H4.66699C5.30275 19.4733 5.8451 18.9691 6.25038 18.3611C6.65565 17.7532 6.91253 17.0587 7.00033 16.3333V12.8333C7.06981 11.3529 7.54084 9.91932 8.36293 8.68618C9.18502 7.45305 10.3272 6.46687 11.667 5.83333Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.834V21.0007C10.5 21.9289 10.8687 22.8191 11.5251 23.4755C12.1815 24.1319 13.0717 24.5007 14 24.5007C14.9283 24.5007 15.8185 24.1319 16.4749 23.4755C17.1313 22.8191 17.5 21.9289 17.5 21.0007V19.834",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1732_1874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsInactiveNavbar);
export default __webpack_public_path__ + "static/media/notifications-inactive-navbar.31a605f3f7e27055d779cc45e6eb2526.svg";
export { ForwardRef as ReactComponent };